export default {
  primaryDark: '#02073a',
  primaryLight: '#fff',
  secondaryBlue: '#2f3676',
  previewBlue: '#0b125c',
  previewBlack: '#000218',
  accentGreen: '#61C378',
  accentYellow: '#ffba49',
  accentRed: '#f05741',
  accentGray1: '#e5e6eb',
  accentGray2: '#888999',
  accentBlue: '#406dbd',
  coolGrey: '#99a0a4',
  lightGrayBlue: '#a9b0b4',
  accentLightgrey: '#d8d1cc',
  background: '#f7f7f7',
  accentBeige: '#f0e8dd',
  lightSkyBlue: '#e0e2e3',
  white: '#ffffff',
  lightBlueGray: '#cfd1d3',
  paleGrey: '#f5f8f9',
  accentLightgray: '#d8d1cc',
  pageBackground: '#f7f7f7',
  paleRed: '#e84b3d',
  darkGreen: '#11852c',
  darkGrey: '#393b51'

}
